import NavigationTabs from './NavigationTabs';

export default NavigationTabs;
